import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import PrimaryAuthLayout from "component/primaryAuthLayout/PrimaryAuthLayout";
import TextField from "component/textField/TextField";
import styles from "./Login.module.css";
import eye_slash from "assets/images/eye-slash.svg";
import eye from "assets/images/eye.svg";
import Checkbox from "component/checkbox/Checkbox";
import AppBackdrop from "component/appBackdrop/AppBackdrop";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router";
import AppButton from "component/button/AppButton";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useLocation } from "react-router-dom";
import { useLogin, fetchPublicKey } from "api/mutations/auth/Login";
import { loginSchema } from "schemas/auth/AuthSchemas";
import TTFSnackbar from "component/AppSnackbars/TTFSnackbar";
import Grid from "@mui/material/Unstable_Grid2";
import AuthModalLayout from "component/authModalLayout/AuthModalLayout";
import { encryptPassword } from "utils/rsaEncrypt";

function Login() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const {
    login,
    loading,
    loginData,
    severity,
    openModal,
    setOpenModal,
    message,
    openToast,
    setOpenToast,
    duration,
  } = useLogin();
  const {
    handleSubmit,
    setValue,
    register,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });
  const [passwordToggler, setPasswordToggler] = useState(true);
  const [publicKey, setPublicKey] = useState(null);

  useEffect(() => {
    setValue("email", state?.email);

    const loadPublicKey = async () => {
    try {
      const key = await fetchPublicKey();
      setPublicKey(key);
      // console.log('Public key set in state: ', key);
    } catch (error) {
      console.error("Failed to fetch public key", error);
    }
  };

  loadPublicKey();

  }, []);

  const handleGoToVerification = () => {
    // console.log('logindata email ', loginData.email)
    navigate("/verification", {
      state: {
        email: loginData.email,
      },
    });
  };

  const handleLoginSubmit = async (data) => {
  if (!publicKey) {
    // console.log("Public key is null or --", publicKey);
    console.error("Public key not loaded");
    return;
  }

  try {
    const encryptedPassword = await encryptPassword(publicKey,data.password);

    const payload = {
      ...data,
      password: encryptedPassword,
    };

    login(payload);
  } catch (error) {
    console.error("Encryption failed", error);
  }
};


  return (
    <PrimaryAuthLayout>
      <div className={styles.login}>
        <div className={styles.heading}>
          <Typography variant="h1">Login</Typography>
          <Typography>
            Kindly provide your email and password to login
          </Typography>
        </div>
        <form onSubmit={handleSubmit(handleLoginSubmit)} className={styles.form}>
          <Grid container spacing={1.5}>
            <Grid xs={12} sm={8}>
              <div className={styles.field}>
                <TextField
                  autoComplete={false}
                  errors={errors}
                  name="email"
                  register={register}
                  required={true}
                  type="text"
                  label="Email"
                  placeholder="Examplejoe@gmail.com"
                />
              </div>
            </Grid>
            <Grid xs={12} sm={8}>
              <div className={styles.field}>
                <TextField
                  autoComplete={false}
                  handleAction={() => {
                    setPasswordToggler(!passwordToggler);
                  }}
                  errors={errors}
                  register={register}
                  name="password"
                  required={true}
                  type={passwordToggler ? "password" : "text"}
                  label="Password"
                  placeholder="Insert Password"
                  icon={passwordToggler ? eye_slash : eye}
                />
              </div>
            </Grid>
            <Grid xs={12} sm={8}>
              <div className={`${styles.field} ${styles.extra_field}`}>
                <label>
                  <input
                    type="checkbox"
                    {...register("remember")}
                    name="remember"
                    id=""
                  />
                  Remember me
                </label>
                <Link to="/forgot-password">Forgot Password ?</Link>
              </div>
            </Grid>
            <Grid xs={12} sm={8}>
              <div className={styles.form_btn}>
                <AppButton
                  loading={loading}
                  fullwidth
                  textColor="#FFFFFF"
                  btnBg="#0089FF"
                  btnText="Submit"
                />
              </div>
            </Grid>
            <Grid xs={12} sm={8}>
              <div className={styles.signup}>
                <Typography>
                  Don’t have an account? Proceed to{" "}
                  <Link to="/signup">Create profile</Link>
                </Typography>
              </div>
            </Grid>
          </Grid>
        </form>
        <TTFSnackbar
          severity={severity}
          message={message}
          open={openToast}
          setOpen={setOpenToast}
          duration={duration}
        />
         <AppBackdrop
          openModal={openModal}
          handleCloseModal={() => {}}
          children={
            <AuthModalLayout
              handleClose={() => {
                setOpenModal(false);
                handleGoToVerification();
              }}
              icon={"info"}
              primaryText="Information"
              secondaryText="You are yet to verify your email. A verification PIN was sent to your mail."
            />
          }
        />
      </div>
    </PrimaryAuthLayout>
  );
}

export default Login;